import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { Result } from '@digibricks/domains';
import { FileByteSize, FileMetadata, FileV2, LinkedEntity, MimeType, FileResourceType, UsageType, FileV2Status } from '../../core';
export var FileV2Mapper = /*#__PURE__*/function () {
  function FileV2Mapper() {
    _classCallCheck(this, FileV2Mapper);
  }

  _createClass(FileV2Mapper, [{
    key: "toDomain",
    value: function toDomain(dto) {
      var mimeType;

      if (dto.mimeType !== undefined && dto.mimeType !== null && dto.mimeType !== '') {
        var mimeResult = MimeType.create(dto.mimeType);

        if (mimeResult.isFailure) {
          return Result.fail(mimeResult.error);
        }

        mimeType = mimeResult.getValue();
      }

      var size;

      if (dto.size !== undefined && dto.size !== null) {
        var sizeResult = FileByteSize.create(dto.size);

        if (sizeResult.isFailure) {
          return Result.fail(sizeResult.error);
        }

        size = sizeResult.getValue();
      }

      var resourceType;

      if (dto.resourceType !== undefined && dto.resourceType !== null) {
        var isNotValid = !Object.values(FileResourceType).includes(dto.resourceType);

        if (isNotValid) {
          return Result.fail('Invalid resource type');
        }

        resourceType = dto.resourceType;
      }

      var usageType;

      if (dto.usageType !== undefined && dto.usageType !== null && dto.usageType !== '') {
        var utResult = UsageType.create(dto.usageType);

        if (utResult.isFailure) {
          return Result.fail(utResult.error);
        }

        usageType = utResult.getValue();
      }

      var status;

      if (dto.status !== undefined && dto.status !== null) {
        var _isNotValid = !Object.values(FileV2Status).includes(dto.status);

        if (_isNotValid) {
          return Result.fail('Invalid status');
        }

        status = dto.status;
      }

      var linkedEntity;

      if (dto.linkedEntity) {
        var leResult = LinkedEntity.create({
          entityType: dto.linkedEntity.entityType,
          entityId: dto.linkedEntity.entityId,
          extra: dto.linkedEntity.extra
        });

        if (leResult.isFailure) {
          return Result.fail(leResult.error);
        }

        linkedEntity = leResult.getValue();
      }

      var metadata;

      if (dto.metadata) {
        var mdResult = FileMetadata.create({
          sourceApp: dto.metadata.sourceApp,
          description: dto.metadata.description
        });

        if (mdResult.isFailure) {
          return Result.fail(mdResult.error);
        }

        metadata = mdResult.getValue();
      }

      return FileV2.create({
        status: status,
        statusName: dto.statusName,
        fileKey: dto.fileKey,
        url: dto.url,
        uploadUrl: dto.uploadUrl,
        expiresAt: dto.expiresAt,
        fileName: dto.fileName,
        mimeType: mimeType,
        size: size,
        resourceType: resourceType,
        usageType: usageType,
        linkedEntity: linkedEntity,
        metadata: metadata,
        ownerId: dto.ownerId,
        extension: dto.extension,
        resourceTypeName: dto.resourceTypeName,
        createdBy: dto.createdBy,
        createdAtUnix: dto.createdAt,
        updatedAtUnix: dto.updatedAt,
        version: dto.version
      }, dto.id);
    }
  }]);

  return FileV2Mapper;
}();